import { cx } from '../cx'

export interface SpinnerProps {
  /** Accessible name; without it the spinner is invisible to a screen reader. */
  readonly label: string
  readonly size?: 'sm' | 'md' | 'lg'
  readonly className?: string
}

const SIZES: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'size-4 border-2',
  md: 'size-6 border-2',
  lg: 'size-10 border-[3px]',
}

/** Indeterminate progress. `role="status"` announces the label once, not on every frame. */
export function Spinner({ label, size = 'md', className }: SpinnerProps) {
  return (
    <span role="status" className={cx('inline-flex items-center gap-2', className)}>
      <span
        aria-hidden="true"
        className={cx(
          'inline-block animate-spin rounded-full border-brand-200 border-t-brand-600',
          SIZES[size],
        )}
      />
      <span className="sr-only">{label}</span>
    </span>
  )
}
